export default __webpack_public_path__ + "static/media/excel.d5ae95d9.svg";